'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _log2 = require('./modules/log');

var _log3 = _interopRequireDefault(_log2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    log: async function log(type, id, meta, isMobile, isProduction) {
        return await (0, _log3.default)(type, id, meta, isMobile, false, isProduction);
    }
};